// TODO: nuke/inline these styles
import "purecss/build/base-min.css";
import "purecss/build/grids-min.css";
import "purecss/build/grids-responsive-min.css";

import "./index.scss";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { router } from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./sentry.ts";

const rootElement = document.getElementById("root");
const queryClient = new QueryClient();

if (!rootElement) {
  throw new Error("Root element is missing.");
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router}/>
    </QueryClientProvider>
  </StrictMode>
);
